<template>
  <div>
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">
          Generate Fee Challan
        </h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body" style="padding-left: 1%; padding-right: 1%; padding-top: 1%">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-4">
            Enter Student Form No.
            <div class="input-group input-group-sm">
              <input type="text" class="form-control" v-mask="'##########'" v-model="formno">
              <span class="input-group-append">
                <button class="btn btn-info btn-flat" type="button" v-on:click="search()">Search</button>
              </span>
            </div>
          </div>
          <div class="col-md-12" v-if="record.length > 0">
            <hr />
            <div class="row">
              <div class="col-md-10 col-sm-6">
                <div class="row">
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label>Form No</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.FormNo">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Applicant Name</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.Name">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Father Name</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.FathersName">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Applicant Mobile</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.MobileNo">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Applicant CNIC</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.CNIC">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Due Date *</label>
                    <input type="date" class="form-control" v-model="duedate">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive" style="margin-top: 8px;">
                      <table class="table table-bordered table-sm" width="100%">
                        <thead class="bg-info">
                          <tr>
                            <th style="width: 10%; text-align: center">Priority</th>
                            <th>Program </th>
                            <th>Category</th>
                            <th>Merit List </th>
                            <th>Merit</th>
                            <th width="10px" style="text-align: center">Action </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in  record">
                            <td style="width: 10%; text-align: center">{{index + 1}}</td>
                            <td>{{item.Program}}</td>
                            <td>{{item.AdmissionCategory}}</td>
                            <td>{{item.MeritList}}</td>
                            <td>{{item.Aggregate.toFixed(3)}}</td>
                            <td style="text-align: center">
                              <input type="checkbox" v-model="item.Select" />
                            </td>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 col-sm-4 col-xga-6">
                <img v-bind:src="st.Image" alt="Student Image" style="height: 110px !important" class="img-thumbnail" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="card-footer" style="text-align: right">
        <button v-if="record.length > 0" type="button" v-on:click="printAdmissionForm()" class="btn btn-primary">View Admission Form</button>
        <button v-if="record.length > 0" type="button" v-on:click="generateFee()" class="btn btn-success">Generate Fee</button>
        <button type="button" v-on:click="cancel()" class="btn btn-danger">Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        formno: '',
        prospects: [],
        choices: [],
        sum: 0,
        Types: 0,
        record: [],
        st: '',
        fee: [],
        duedate: '2021-12-03',
      }
    },

    created: function () {
    },

    methods: {
      search: function () {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/searchFormNo?param=' + vm.formno)
          .then(function (pl) {
            vm.record = pl.data;
            if (vm.record.length > 0) {
              vm.st = vm.record[0];
            }
            else {
              toastr.error("No student found");
              vm.st = '';
            }
            endReq();
          })
      },

      loadDepartment() {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadDepartments?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID)
          .then(function (res) {
            vm.departments = res.data;
            endReq();
          })
      },

      loadPrograms() {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadPrograms?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID + "_" + vm.filter.DepartmentID)
          .then(function (res) {
            vm.programs = res.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      generateFee() {
        var vm = this;
        var check = 0;
        var prog = 0;
        var catID = 0;
        vm.record.forEach(function (item, ind) {
          if (item.Select) {
            check = check + 1;
            prog = item.ProgramID;
            catID = item.AdmissionCategoryID;
          }
        });
        if (check > 1) {
          toastr.error("Please select only one program", "Error!");
          return;
        }
        if (check == 0) {
          toastr.error("Please select one program", "Error!");
          return;
        }
        if (vm.duedate == '' || vm.duedate == null) {
          toastr.error("Due Date is required", "Error!");
          return;
        }
        startReq();
        axios.post('/api/FeeApi/generateFee?progID=' + prog + '&dueDate=' + vm.duedate + '&psID=' + vm.st.ProspectStudentID + '&catID=' + catID)
          .then(function (pl) {
            endReq();
            if (pl.data.status == false) {
              toastr.error(pl.data.msg, "Error!");
            }
            else {
              window.open("../Fee/ProspectStudentChallanPrint", "_blank");
            }
          })
      },

      cancel() {
        window.location.reload();
      },

      printAdmissionForm() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/printAdmissionForm?ID=' + vm.st.ProspectStudentID)
          .then(function (res) {
            endReq();
            window.open(res.data.url, '_blank');
          })
          .catch(function (error) {
            console.log(error);
          })
      },
    }
  })
</script>

<style>
/*  table thead tr th {
    background-color: #605ca8;
    color: white;
  }*/

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fee/prospectstudentfeegeneration.vue